"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

// import useResolveServiceActionName from '@sprinx/react-api-client/useResolveServiceActionName';

/**
 * returns
 * available: bool, - je skladem
 * shippingDate: date - datum odeslani za predpokladu  latestOrderTime
 * latestOrderTime, - datum, do kdy musi objednat (2020-01-01 13:30:00) nebo undefined - zmamena dnes, po vyprseni latestOrderTime je potreba zavolat data znovu

**/
var isStaticBuild = typeof document === 'undefined';

function useProductShippingDateServiceCall(options) {
  // const { clientCode, serviceNames } = useOrdersContext();
  // const serviceName = useResolveServiceActionName(null, 'v1.productContent.longDescription' /* , serviceNames */);
  return (0, _useServiceCall.default)((0, _useDefaults.default)(options, {
    clientCode: 'api',
    returnOnlyAction: true
  }), function (client, _ref) {
    var id = _ref.id,
        targetCountry = _ref.targetCountry;
    return client.call("/v1/products/".concat(id, "/shippingDate"), {
      targetCountry: targetCountry
    }, {
      method: 'get'
    });
  });
}

function useProductShippingDateServiceCallDummy() {
  return function () {
    return Promise.resolve(undefined);
  };
}

var _default = isStaticBuild ? useProductShippingDateServiceCallDummy : useProductShippingDateServiceCall;

exports.default = _default;